<template>
  <div class="theoryexam">
    <el-header style="height:40px;">
      <el-page-header @back="goBack" content="试题详情">
      </el-page-header>
    </el-header>
   <template  v-if="info.test"> 
   <div class="testname" v-show="info.test.name">{{info.test.name}}<span>(总分{{info.test.score}})</span></div>
   </template>
 
    <div class="testname" v-show="timedjs">考试结束倒计时：{{timedjs}}<span> (请注意考试时间，确保考试结束前提交试卷)</span></div>
    <!-- 单选题 -->
    <div class="singlechoice">
      <div class="questiontype">单选题<span>(共{{Singlechoice.length}}题)</span></div>
      <ul>
        <li v-for="(item,index) in Singlechoice" class="question">
          <div class="title">
            {{index+1}}、{{item.question}}
            <span>({{item.poins}}分)</span>
          </div>
          <template v-if="item.content1.length>0">
            <div class="questionsitem" v-for="(items,index1) in item.content1" :class="{'active':items.select==true}" :key="index1" @click="goSingle(item,items)">
              <i class="el-icon-success"></i>{{items.name}}
            </div>
          </template>
        </li>
      </ul>
    </div>
    <!-- 多选题 -->
    <div class="singlechoice">
      <div class="questiontype">多选题<span>(共{{checkboxchoice.length}}题)</span></div>
      <ul>
        <li v-for="(item,index) in checkboxchoice" class="question">
          <div class="title">
            {{index+1}}、{{item.question}}
            <span>({{item.poins}}分)</span>
          </div>
          <template v-if="item.content1.length>0">
            <div class="questionsitem" v-for="(items,index1) in item.content1" :class="{'active':items.select==true}" :key="index1" @click="gocheckbox(item,items)">
              <i class="el-icon-success"></i>{{items.name}}
            </div>
          </template>
        </li>
      </ul>
    </div>
    <!--判断题  -->
    <div class="singlechoice">
      <div class="questiontype">判断题<span>(共{{decide.length}}题)</span></div>
      <ul>
        <li v-for="(item,index) in decide" class="question">
          <div class="title">
            {{index+1}}、{{item.question}}
            <span>({{item.poins}}分)</span>
          </div>
          <template v-if="item.content1.length>0">
            <div class="questionsitem" v-for="(items,index1) in item.content1" :class="{'active':items.select==true}" :key="index1" @click="godecide(item,items)">
              <i class="el-icon-success"></i>{{items.name}}
            </div>
          </template>
        </li>
      </ul>
    </div>
    <!--填空题  -->
    <div class="singlechoice">
      <div class="questiontype">填空题<span>(共{{fill.length}}题)</span></div>
      <ul>
        <li v-for="(item,index) in fill" class="question">
          <div class="title">
            {{index+1}}、{{item.question}}
            <span>({{item.poins}}分)</span>
          </div>
          <div class="answer">
            <div>答案:</div>
            <el-input type="textarea" :rows="2" placeholder="答案之间请用空格隔开" v-model="item.content1" @input="input1">
            </el-input>
          </div>
        </li>
      </ul>
    </div>
    <!--名词解释题  -->
    <div class="singlechoice">
      <div class="questiontype">名词解释题<span>(共{{definitions.length}}题)</span></div>
      <ul>
        <li v-for="(item,index) in definitions" class="question">
          <div class="title">
            {{index+1}}、{{item.question}}
            <span>({{item.poins}}分)</span>
          </div>
          <div class="answer">
            <div>答案:</div>
            <el-input type="textarea" :rows="2" placeholder="请输入答案" v-model="item.content1">
            </el-input>
          </div>
        </li>
      </ul>
    </div>
    <!--论述题  -->
    <div class="singlechoice">
      <div class="questiontype">论述题<span>(共{{discuss.length}}题)</span></div>
      <ul>
        <li v-for="(item,index) in discuss" class="question">
          <div class="title">
            {{index+1}}、{{item.question}}
            <span>({{item.poins}}分)</span>
          </div>
          <div class="answer">
            <div>答案:</div>
            <el-input type="textarea" :rows="2" placeholder="请输入答案" v-model="item.content1">
            </el-input>
          </div>
        </li>
      </ul>
    </div>
    <!--简答题  -->
    <div class="singlechoice">
      <div class="questiontype">简答题<span>(共{{shortanswer.length}}题)</span></div>
      <ul>
        <li v-for="(item,index) in shortanswer" class="question">
          <div class="title">
            {{index+1}}、{{item.question}}
            <span>({{item.poins}}分)</span>
          </div>
          <div class="answer">
            <div>答案:</div>
            <el-input type="textarea" :rows="2" placeholder="请输入答案" v-model="item.content1">
            </el-input>
          </div>
        </li>
      </ul>
    </div>
    <el-button class="" @click="submitbtn()" type="primary">提交</el-button>
  </div>
</template>

<script>
export default {
  props: {

  },
  data() {
    return {
      Singlechoice: [],//1单选
      checkboxchoice: [],//2多选  
      decide: [],//3判断
      fill: [],//4填空题 
      definitions: [],//5名词解释题 
      discuss: [],//6：论述题
      shortanswer: [],//7：简答题   
      zmlist: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'],
      answer: [],
      id: [],
      testid: '',
      typelist: [],
      info: {},
      timedjs: ''
    };
  },
  computed: {

  },
  created() {
    this.itestid = this.$route.query.testid
    this.getdetails(this.itestid);
    var that = this;
    var timer1 = setInterval(function () {
      var running = 0;
      var nowdate = new Date().getTime()
      //var enddate = new Date(that.info.end).getTime();
      var enddate = new Date("2020-06-15 18:05").getTime();
      var time = enddate - nowdate
      if (time >= 0) {
        // console.log()
        that.timedjs = that.changeTime(time)
      } else {
        that.message.error("考试时间到！")
        clearInterval(that.timer)
      }
      //   if (running) {
      //     that.tabledata = that.tabledata;
      //     that.$forceUpdate()
      //   }
    }, 1000);
    this.timer = timer1;
  },
  methods: {
    //type 1:单选题 2：多选题 3：判断题 4：填空题 5名词解释题 6：论述题 7：简单题
    getdetails(id) {
      this.$http.theorytest(id)
        .then(res => {
          if (res.data) {

            var nowdate = new Date().getTime()
            var enddate = new Date(res.data.end).getTime();
            var startdate = new Date(res.data.start).getTime()
            var flags = (nowdate > enddate) || (startdate > nowdate)
            //   if (flags) {
            //    this.$router.back()
            //   }
            if (res.data.test.question.length > 0) {
              var { question } = res.data.test
              this.testid = res.data.id
              var Singlechoice = []
              var checkboxchoice = []
              var decide = []
              var fill = []
              var definitions = []
              var discuss = []
              var shortanswer = []
              var id = []
              var typelist = []
              question.forEach(val => {
                id.push(val.id)
                typelist.push(val.type)
                if (val.type == 1) {
                  var Singlechoicesession = JSON.parse(sessionStorage.getItem('Singlechoice'))
                  if (Singlechoicesession && Singlechoicesession.length > 0) {
                    Singlechoice = Singlechoicesession;
                  } else {
                    val.content = val.content.replace(/\s/g, "").split(/[a-z|A-Z]\./g)
                    val.content = val.content.slice(1, val.content.length)
                    var arr = []
                    val.content.forEach((ele, i) => {
                      var obj = {
                        name: this.zmlist[i] + '.' + ele,
                        select: false
                      }
                      arr.push(obj)
                    })
                    val.content1 = arr
                    Singlechoice.push(val)
                  }

                } else if (val.type == 2) {
                  var checkboxchoicesession = JSON.parse(sessionStorage.getItem('checkboxchoice'))
                  if (checkboxchoicesession && checkboxchoicesession.length > 0) {
                    checkboxchoice = checkboxchoicesession;
                  } else {
                    val.content = val.content.replace(/\s/g, "").split(/[a-z|A-Z]\./g)
                    val.content = val.content.slice(1, val.content.length)
                    var arr = []
                    val.content.forEach((ele, i) => {
                      var obj = {
                        name: this.zmlist[i] + '.' + ele,
                        select: false
                      }
                      arr.push(obj)
                    })
                    val.content1 = arr
                    checkboxchoice.push(val)
                  }

                } else if (val.type == 3) {
                  var decidesession = JSON.parse(sessionStorage.getItem('decide'))
                  if (decidesession && decidesession.length > 0) {
                    decide = decidesession;
                  } else {
                    val.content1 = [
                      {
                        name: "正确",
                        select: false
                      },
                      {
                        name: "错误",
                        select: false
                      },
                    ]
                    decide.push(val)
                  }

                } else if (val.type == 4) {
                  var fillsession = JSON.parse(sessionStorage.getItem('fill'))
                  if (fillsession && fillsession.length > 0) {
                    fill = fillsession;
                  } else {
                    val.content1 = ''
                    fill.push(val)
                  }


                } else if (val.type == 5) {
                  var definitionssession = JSON.parse(sessionStorage.getItem('fill'))
                  if (definitionssession && definitionssession.length > 0) {
                    definitions = definitionssession;
                  } else {
                    val.content1 = ''
                    definitions.push(val)
                  }

                } else if (val.type == 6) {
                  var discussssession = JSON.parse(sessionStorage.getItem('fill'))
                  if (discussssession && discussssession.length > 0) {
                    discuss = discussssession;
                  } else {
                    val.content1 = ''
                    discuss.push(val)
                  }

                } else {
                  var shortanswerssession = JSON.parse(sessionStorage.getItem('fill'))
                  if (shortanswerssession && shortanswerssession.length > 0) {
                    shortanswer = shortanswerssession;
                  } else {
                    val.content1 = ''
                    shortanswer.push(val)
                  }
                }
              })
              //   this.Singlechoice
              //   console.log(Singlechoice)
              this.Singlechoice = Singlechoice
              this.checkboxchoice = checkboxchoice
              this.decide = decide
              this.fill = fill
              this.definitions = definitions
              this.discuss = discuss
              this.shortanswer = shortanswer
              this.id = id;
              this.typelist = typelist;
              this.info = res.data;
            }
          } else {
          }
        })
    },
    goSingle(item, items) {
      item.content1.forEach(element => {
        element.select = false;
      });
      items.select = true;
      sessionStorage.setItem("Singlechoice", JSON.stringify(this.Singlechoice));
    },
    gocheckbox(item, items) {
      items.select = !items.select;
      sessionStorage.setItem("checkboxchoice", JSON.stringify(this.checkboxchoice));
    },
    godecide(item, items) {
      items.select = !items.select;
      sessionStorage.setItem("decide", JSON.stringify(this.decide));
    },
    input1() {
      sessionStorage.setItem("fill", JSON.stringify(this.fill));
    },
    input2() {
      sessionStorage.setItem("definitions", JSON.stringify(this.definitions));
    },
    input3() {
      sessionStorage.setItem("discuss", JSON.stringify(this.discuss));
    },
    input4() {
      sessionStorage.setItem("shortanswer", JSON.stringify(this.shortanswer));
    },
    submitbtn() {
      //  this.Singlechoice = Singlechoice
      //               this.checkboxchoice = checkboxchoice
      //               this.decide = decide
      //               this.fill = fill
      //               this.definitions = definitions
      //               this.discuss = discuss
      //               this.shortanswer = shortanswer
      var arr1 = new Array(this.Singlechoice.length).fill('');
      var arr2 = new Array(this.checkboxchoice.length).fill('');
      var arr3 = new Array(this.decide.length).fill('');
      var arr4 = new Array(this.fill.length).fill('');
      var arr5 = new Array(this.definitions.length).fill('');
      var arr6 = new Array(this.discuss.length).fill('');
      var arr7 = new Array(this.shortanswer.length).fill('');
      //1单选题

      for (var i = 0; i < this.Singlechoice.length; i++) {
        for (var j = 0; j < this.Singlechoice[i].content1.length; j++) {
          if (this.Singlechoice[i].content1[j].select) {

            // arr1.push(this.Singlechoice[i].content1[j].name.split('.')[0])
            arr1.splice(i, 1, this.Singlechoice[i].content1[j].name.split('.')[0])
          }
        }
      }
      //console.log(arr1)

      //2多选题
      for (var i = 0; i < this.checkboxchoice.length; i++) {
        var str = [];
        for (var j = 0; j < this.checkboxchoice[i].content1.length; j++) {

          if (this.checkboxchoice[i].content1[j].select) {
            //=str+this.checkboxchoice[i].content1[j].name.split('.')[0]
            str.push(this.checkboxchoice[i].content1[j].name.split('.')[0])
            //arr.push(this.checkboxchoice[i].content1[j].select.name)
          }
        }
        // console.log(str)
        // arr2.push(str.json(' '))
        arr2.splice(i, 1, str.join(' '))
      }
      //  console.log(arr2)
      //    return;
      //3：判断题
      for (var i = 0; i < this.decide.length; i++) {
        for (var j = 0; j < this.decide[i].content1.length; j++) {

          if (this.decide[i].content1[j].select) {
            arr3.splice(i, 1, this.decide[i].content1[j].name)
          }
        }

      }
      // console.log(arr3)
      //4填空题
      for (var i = 0; i < this.fill.length; i++) {
        // arr4.push(this.fill[i].content1)
        arr4.splice(i, 1, this.fill[i].content1)
      }
      //console.log(arr4)
      //5名词解释题
      for (var i = 0; i < this.definitions.length; i++) {
        //arr5.push(this.definitions[i].content1)
        arr5.splice(i, 1, this.definitions[i].content1)
      }
      //6：论述题
      for (var i = 0; i < this.discuss.length; i++) {
        // arr6.push(this.discuss[i].content1)
        arr6.splice(i, 1, this.discuss[i].content1)
      }
      //7：简答题
      for (var i = 0; i < this.shortanswer.length; i++) {
        //arr7.push(this.shortanswer[i].content1)
        arr7.splice(i, 1, this.shortanswer[i].content1)
      }
      var arrall = [...arr1, ...arr2, ...arr3, ...arr4, ...arr5, ...arr6, ...arr7]
      // console.log(arrall)
      // return;
      this.$confirm('提交前请检查试卷是否全部完成,是否提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        var params = {
          logid: this.testid,
          cid: this.id,
          answer: arrall,
          type: this.typelist
        }
        this.$http.theorysubmit(params)
          .then(res => {
            if (res.code == 200) {
              this.$alert('提交成功', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  this.$router.back()

                }

              });

            } else {
              this.$message.error(res.message)
            }
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });

    },
    //倒计时转换
    changeTime(ms) {
      if (!ms) return;
      var time = new Date(ms);
      function c(a, b) {
        var x = Math.floor(ms / a % b);
        if (x < 10) {
          return '0' + x;
        }
        return '' + x;
      }
      var a = (c(3600000, 24) + c(60000, 60) + c(1000, 60)).split("");
      var day = "";
      var day2 = "";
      if (ms > 86400000 && ms < 360000000) {
        day = '' + Math.floor(ms / 86400000) * 24;
        day2 = day.split('');
        var a0 = (+a[0]) + (+day2[0]),
          a1 = (+a[1]) + (+day2[1]);
        if (a1 >= 10) {
          a0 = a0 + Math.floor(a1 / 10);
          a1 = Math.floor(a1 % 10);
        }
        return a0 + "" + a1 + "时" + a[2] + "" + a[3] + "分" + a[4] + "" + a[5] + '秒'
      } else if (ms >= 360000000) {
        day = Math.floor(ms / 86400000) + "天";
        return day + "" + a[0] + "" + a[1] + "时" + a[2] + "" + a[3] + "分" + a[4] + "" + a[5] + '秒'
      } else {
        return day + "" + a[0] + "" + a[1] + "时" + a[2] + "" + a[3] + "分" + a[4] + "" + a[5] + '秒'
      }
    },
    goBack() {
      this.$router.back()
    },

  },
  destroyed() {
    clearInterval(this.timer)
    sessionStorage.removeItem("Singlechoice");
    sessionStorage.removeItem("checkboxchoice");
    sessionStorage.removeItem("decide");
    sessionStorage.removeItem("fill");
    sessionStorage.removeItem("definitions");
    sessionStorage.removeItem("discuss");
    sessionStorage.removeItem("shortanswer");
  }
};
</script>

<style  lang="less">
.theoryexam {
  .testname {
    text-align: center;
    font-size: 18px;
    color: #333333;
    font-weight: bold;
    margin-bottom: 10px;
    span {
      font-size: 14px;
      font-weight: normal;
    }
  }
  .singlechoice {
    .questiontype {
      font-size: 18px;
      color: #333333;
      margin-bottom: 10px;
      font-weight: bold;
      span {
        font-weight: normal;
        font-size: 14px;
      }
    }
    ul {
      li {
        list-style: none;
        margin-bottom: 20px;
        .title {
          font-size: 16px;
          color: #333333;
          //   font-weight: bold;
          margin-bottom: 10px;
          span {
            font-size: 14px;
          }
        }
        .questionsitem {
          color: #333333;
          font-size: 15px;
          padding: 10px 0;
          text-indent: 2em;
          position: relative;
          .el-icon-success {
            color: #ccc;
            font-size: 20px;
            //  position: absolute;
            top: 0;
            left: 0;
          }
        }
        .active {
          color: #409eff;
          .el-icon-success {
            color: #409eff;
          }
        }
        .answer {
          div {
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/assessment/theoryexam.vue